var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalEnergy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 90 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.838 96C37.9475 94.9984 37.6563 94.4375 37.901 92.3942C39.0882 82.4341 40.2683 72.4741 41.4415 62.5141C41.606 61.1479 41.7749 59.7857 41.9564 58.2792H22.7051C19.557 58.2792 18.27 56.3441 19.6626 53.6918C28.6791 36.4454 37.7111 19.2043 46.7586 1.96852C46.8842 1.71528 47.0251 1.46915 47.1806 1.23133C47.472 0.773865 47.9074 0.414842 48.4253 0.204935C48.9432 -0.00497241 49.5175 -0.0551629 50.067 0.0614481C50.6511 0.190074 51.1708 0.505565 51.5389 0.954957C51.9069 1.40435 52.1009 1.96028 52.0883 2.52942C51.9448 4.67688 51.6664 6.82034 51.4216 8.93975C50.6747 15.2058 49.9024 21.4679 49.1428 27.734L47.8768 38.3431C47.8389 38.6476 47.8093 38.9481 47.7671 39.3447H48.8686C55.2533 39.3447 61.638 39.3447 68.0227 39.3447C69.9638 39.3447 71.1413 40.5467 70.8205 42.1492C70.7241 42.544 70.5707 42.9241 70.3648 43.2791C61.2948 60.2184 52.2122 77.151 43.1169 94.0769C42.716 94.8261 41.8509 95.351 41.2095 95.98L39.838 96Z",
    fill: "url(#paint0_linear_1239_3809)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5934 6L35.2174 12.4704C34.3735 14.073 33.5506 15.7277 32.6476 17.3182C32.3876 17.7688 31.9865 18.1314 31.4998 18.3559C24.0854 21.517 18.3885 26.4449 14.7383 33.34C9.91494 42.4467 9.62795 51.7697 13.9576 61.1048C17.8019 69.3941 24.3808 75.0713 33.2848 78.3325L33.922 78.5769C33.9941 78.6233 34.0606 78.677 34.1203 78.7372C33.7237 82.0786 33.327 85.452 32.9261 88.8374C17.363 85.2797 0.183763 70.1914 0.221743 48.0077C0.251282 24.9706 18.7302 8.47599 38.5934 6Z",
    fill: "url(#paint1_linear_1239_3809)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4268 89.9574L52.2707 88.419C54.0093 85.1657 55.731 81.9005 57.5161 78.6673C57.7878 78.1891 58.2076 77.8017 58.7188 77.5575C68.7115 73.1063 75.3072 65.8907 77.9657 55.7143C80.5272 45.9025 78.489 36.8118 72.1718 28.6667C68.2641 23.6234 62.862 19.8001 56.6552 17.685C56.4062 17.5969 56.1657 17.5007 55.8112 17.3725C56.2248 13.9697 56.6369 10.5669 57.0476 7.16406C74.594 11.3949 91.7437 28.5665 89.5409 51.8721C87.4478 74.1239 68.4583 88.1305 51.4268 89.9574Z",
    fill: "url(#paint2_linear_1239_3809)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1239_3809",
    x1: 39.5624,
    y1: 14.7813,
    x2: 105.336,
    y2: 20.5719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AB55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74BB45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1239_3809",
    x1: 15.3854,
    y1: 18.7547,
    x2: 64.2361,
    y2: 22.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AB55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74BB45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1239_3809",
    x1: 66.5645,
    y1: 19.912,
    x2: 115.332,
    y2: 23.5956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AB55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74BB45"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalEnergy);
export default __webpack_public_path__ + "static/media/total_energy.477ce306.svg";
export { ForwardRef as ReactComponent };